import { z } from "zod";

export const getSidebarSchema = () => {
  const t =
    (window as any).commonVariables?.translations?.contactForm?.validation ||
    {};

  return z.object({
    name: z
      .string()
      .min(2, t.nameMin || "Lütfen adınızı ve soyadınızı giriniz."),
    email: z
      .string()
      .email(t.emailInvalid || "Lütfen geçerli bir e-posta adresi giriniz."),
    phone: z.string().min(10, "Lütfen geçerli bir telefon numarası giriniz."),
    message: z.string().optional(),
    project_name: z.string().optional(),
    nickname: z.string().optional(),
    form_load_timestamp: z.coerce.number(),

    consent: z.any().refine((val) => val === "on", {
      message: "Lütfen bilgilendirme yazısını okuyup onaylayınız.",
    }),
  });
};
